import { reactive } from "vue";
import { TabsType } from "./project-status-tabs.interface";
export const projectStatusArr = reactive<TabsType[]>([
  {
    type: 'all',
    name: "全部",
  },
  {
    type: "dlx",
    name: "待立项",
  },
  {
    type: "dtb",
    name: "已立项",
  },
  {
    type: "tbz",
    name: "投标中",
  },
  {
    type: "yzb",
    name: "已中标",
  },
  {
    type: "ylb",
    name: "已落标",
  },
  {
    type: "dsg",
    name: "待施工",
  },
  {
    type: "sgz",
    name: "施工中",
  },
  {
    type: "yjg",
    name: "已竣工",
  },
  {
    type: "ygb",
    name: "已关闭",
  },
]);

export const contractStatusArr = reactive<TabsType[]>([
  {
    type: 'all',
    name: "全部",
  },
  {
    type: "dsp",
    name: "待审批",
  },
  {
    type: "dqy",
    name: "待签约",
  },
  {
    type: "dly",
    name: "待履约",
  },
  {
    type: "lyz",
    name: "履约中",
  },
  {
    type: "shz",
    name: "变更中",
  },
  {
    type: "ywc",
    name: "已完成",
  },
  {
    type: "yzz",
    name: "已终止",
  },
]);
